export default __webpack_public_path__ + "8fabe2f58080e9339715a1f52f6004ab.png";